'use client';
/**
 * 시군구 배너·홈 배너 자리에 유료 광고가 비었을 때 쓰는 자체 안내 소재 — «이 자리 광고 · 자세히 보고 바로 신청».
 * 누르면 /advertise 의 그 상품 단락(#district·#home, 시군구 미리 고름) → 단락의 «이 광고 바로 신청» → /ads/buy. 문의 폼 없음.
 * 낼지 말지는 서버에서 순수 함수 shouldShowEmptySlotAd({ hasPaid, share: cfg.empty_slot_share, seed, excluded })
 * (src/lib/ads/acq-core.ts)로 정한다 — 기본 0.3, 하우스 광고(src/lib/rx/ad-slots.ts 'house')가 더 자주 나온다.
 * ⛔ 금액 문구 없음. 자리 높이는 호출부 슬롯 높이(minHeight)로 미리 확보(CLS 0).
 */
import { advertiseHref } from '@/lib/ads/buy-link';
import { trackAdvertiseClick } from './track';

export interface EmptySlotHouseAdProps {
  placement: 'district' | 'home';
  /** district 면 그 페이지의 districtKey('부산:연제구'). siteId 는 예전 호출 호환용(시군구 배너 자리라 쓰지 않음) */
  districtKey?: string | null;
  siteId?: string | null;
  minHeight?: number;
  /** 레인 R — 서버가 정한 짧은 한 줄(«이 시군구 배너는 글 N편·현장 K곳에 함께 나갑니다») · 없으면 줄 없음 */
  reachLine?: string | null;
}

export default function EmptySlotHouseAd({ placement, districtKey, minHeight = 120, reachLine = null }: EmptySlotHouseAdProps) {
  const from = placement === 'home' ? 'empty_home' : 'empty_district';
  const href = advertiseHref({ product: placement, from, district: placement === 'district' ? districtKey ?? null : null });
  const area = placement === 'home' ? '카더라 첫 화면' : districtKey ? `${districtKey.split(':')[1] ?? ''} 현장·글` : '이 지역 현장·글';
  return (
    <a
      href={href}
      rel="nofollow"
      onClick={() => trackAdvertiseClick(from)}
      className="kd-acq-empty"
      style={{
        display: 'flex', flexDirection: 'column', justifyContent: 'center', gap: 6, minHeight, boxSizing: 'border-box',
        padding: '16px 18px', borderRadius: 'var(--radius-md, 12px)', border: '1px dashed var(--border, #cbd5e1)',
        background: 'var(--bg-surface, #fff)', color: 'var(--text-primary, #0f172a)', textDecoration: 'none',
      }}
    >
      <span style={{ fontSize: 'var(--fs-xs, 12px)', color: 'var(--text-tertiary, #64748b)' }}>카더라 안내 · 이 자리 광고</span>
      <strong style={{ fontSize: 'var(--fs-md, 16px)', lineHeight: 1.4 }}>분양 현장을 {area}에 알리세요</strong>
      {reachLine ? <span data-empty-reach="" style={{ fontSize: 'var(--fs-xs, 12px)', color: 'var(--text-secondary, #475569)' }}>{reachLine}</span> : null}
      <span style={{ fontSize: 'var(--fs-sm, 14px)', color: 'var(--text-secondary, #475569)' }}>2주·4주 단위 · 자세히 보고 바로 신청 →</span>
    </a>
  );
}
